import { Link } from 'react-router-dom';
import '../../css/FootballLeagues.css';
import afcLogo from '../../assets/afc-logo.png';
import nfcLogo from '../../assets/nfc-logo.png';

const FootballLeagues = () => {
    return (
        <main id="football-content">
            <h2 id="football-quest">What Football Conference Would You Like To See?</h2>

            <section id="football-section">
                <Link to="/sports/football/afc" className="football-link">
                    <div id="football-container">
                        <img id="football-img" src={afcLogo} alt="AFC" />
                    </div>
                </Link>

                <Link to="/sports/football/nfc" className="football-link">
                    <div id="football-container">
                        <img id="football-img" src={nfcLogo} alt="NFC" />
                    </div>
                </Link>
            </section>
        </main>
    );
};

export default FootballLeagues;